import { useContext } from 'react';
import { AuthContext } from './context.js';
import type { AuthState } from './context.js';

export function useAuth(): AuthState {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth() cannot be used without an <AuthProvider>');
  }

  return context;
}
